export const RegistrationPlate = ({
  reg,
  className = "",
}: {
  reg: string | null;
  hideIcon?: boolean;
  className?: string;
}) => {
  return reg ? (
    <div
      className={`flex items-center justify-center rounded bg-amber-300 font-bold text-black w-25 px-2 py-[3px] ${className}`}
      title={reg}
    >
      <span className={`truncate text-m`}>{reg}</span>
    </div>
  ) : (
    "-"
  );
};
